/* Zarina Theme JS */



// CART STATE
let cartItems = [];
let cartCount = 0;

// CART DRAWER
const cartOverlay = document.querySelector('.cart-overlay');
const cartDrawer = document.querySelector('.cart-drawer');
const cartCountEl = document.querySelector('.cart-count');
const allProductsUrl = window.themeRoutes?.allProducts || '/collections/all';
const cartAddonConfig = window.themeCartAddons || {};
const CART_INSURANCE_HANDLE = cartAddonConfig.insurance?.handle || 'premium-fraktforsikring';
const CART_INSURANCE_VARIANT_ID = Number(cartAddonConfig.insurance?.variantId || 0);
const CART_INSURANCE_PRICE = Number(cartAddonConfig.insurance?.price || 0);
const CART_INSURANCE_LABEL = cartAddonConfig.insurance?.label || 'Premium fraktforsakring';
const CART_TRIMMER_HEADS_HANDLE = cartAddonConfig.trimmerHeads?.handle || 'ekstra-trimmerhoder';
const CART_TRIMMER_HEADS_VARIANT_ID = Number(cartAddonConfig.trimmerHeads?.variantId || 0);
const CART_TRIMMER_HEADS_PRICE = Number(cartAddonConfig.trimmerHeads?.price || 0);
const CART_TRIMMER_HEADS_LABEL = cartAddonConfig.trimmerHeads?.label || 'Extra trimmerhuvuden';
const CART_TRIMMER_HEADS_VARIANT_BY_COLOR = cartAddonConfig.trimmerHeads?.variantByColor || {};
const CART_TRIMMER_HEADS_VARIANT_IMAGE_BY_ID = cartAddonConfig.trimmerHeads?.variantImageById || {};
const CART_SILKTRIM_HANDLE = cartAddonConfig.silktrimHandle || 'silktrim';
const CART_SILKTRIM_VARIANT_COLOR_BY_ID = cartAddonConfig.silktrimVariantColorById || {};
const CART_PREF_INSURANCE = 'zarina-insurance-enabled-v2';
const CART_PREF_TRIMMER_HEADS = 'zarina-trimmer-heads-enabled-v2';
const CART_LAST_SILKTRIM_COLOR_KEY = 'zarina-last-silktrim-color';
const CART_SHIELD_SVG =
  '<path fill-rule="evenodd" clip-rule="evenodd" d="M18.5 12c-3.036 0-5.5 2.463-5.5 5.5s2.464 5.5 5.5 5.5c3.035 0 5.5-2.463 5.5-5.5s-2.465-5.5-5.5-5.5zm-6.634 9h-11.866v-20h22v9.866c-.62-.328-1.292-.572-2-.716v-7.15h-7v6h-4v-6h-7v16h9.15c.144.708.388 1.38.716 2zm6.019-2.94l-1.259-1.182-.962.989 2.24 2.133 3.765-3.834-.979-.97-2.805 2.864zm-8.885-1.06h-5v-2h5v2z"/>';
let cartAddonSyncInFlight = false;
let cartAddonSyncPending = false;

let _scrollY = 0;
function lockScroll() {
  _scrollY = window.scrollY;
  document.body.style.position = 'fixed';
  document.body.style.top = `-${_scrollY}px`;
  document.body.style.left = '0';
  document.body.style.right = '0';
  document.body.style.width = '100%';
}
function unlockScroll() {
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.left = '';
  document.body.style.right = '';
  document.body.style.width = '';
  window.scrollTo(0, _scrollY);
}

function openCart() {
  cartOverlay?.classList.add('active');
  cartDrawer?.classList.add('active');
  lockScroll();
}
function closeCart() {
  cartOverlay?.classList.remove('active');
  cartDrawer?.classList.remove('active');
  unlockScroll();
}

document.querySelector('.cart-btn')?.addEventListener('click', openCart);
document.querySelector('.cart-overlay')?.addEventListener('click', closeCart);
document.querySelector('.cart-drawer__close')?.addEventListener('click', closeCart);

// FETCH CART
async function fetchCart() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    updateCartUI(cart);
  } catch(e) {}
}

const variantCompareCentsMap = new Map();

function registerVariantCompareFromVariants(variants) {
  if (!Array.isArray(variants)) return;
  variants.forEach((v) => {
    const id = Number(v.id);
    if (!id) return;
    const compare = parseKrText(v.compare);
    if (compare > 0) variantCompareCentsMap.set(id, compare);
  });
}

function getVariantCompareCents(variantId) {
  return variantCompareCentsMap.get(Number(variantId)) || 0;
}

function buildLineItemCompareProps(variantId, unitPriceCents) {
  const compare = getVariantCompareCents(variantId);
  if (!compare) return null;
  const unit = unitPriceCents || 0;
  if (compare <= unit) return null;
  return { _compare_cents: String(compare) };
}

function _effectiveCompare(item) {
  const unitFinal = item.final_price || 0;
  if (item.compare_at_price && item.compare_at_price > unitFinal) return item.compare_at_price;
  const prop = cartItemProp(item, '_compare_cents');
  if (prop) {
    const cents = parseInt(prop, 10);
    if (cents > unitFinal) return cents;
  }
  const variantId = item.variant_id || item.id;
  const mapped = variantCompareCentsMap.get(Number(variantId));
  if (mapped && mapped > unitFinal) return mapped;
  return null;
}

function parseMoneyMajor(text) {
  // Swedish money: "kr 1.599,00" / "1 099,00 kr" / "659,00 kr"
  let s = String(text || '')
    .replace(/[^\d,.\s]/g, '')
    .replace(/\s/g, '');
  if (!s) return 0;
  if (s.includes(',') && s.includes('.')) {
    // Dot = thousands, comma = decimals
    s = s.replace(/\./g, '').replace(',', '.');
  } else if (s.includes(',')) {
    s = s.replace(',', '.');
  }
  return parseFloat(s) || 0;
}

function parseKrText(text) {
  return Math.round(parseMoneyMajor(text) * 100);
}

const DEFAULT_BUNDLE_COMPARES = { 1: '999 kr', 2: '1 665 kr', 3: '2 398 kr' };

function bundleCompareCents(bundleQty) {
  const compareMap = window._BUNDLE_COMPARES || DEFAULT_BUNDLE_COMPARES;
  const compareText = compareMap[bundleQty];
  return compareText ? parseKrText(compareText) : 0;
}

function bundleCompareCentsForGroup(first, bundleQty) {
  const stored = cartItemProp(first, '_bundle_compare_cents');
  if (stored) {
    const cents = parseInt(stored, 10);
    if (cents > 0) return cents;
  }
  return bundleCompareCents(bundleQty);
}

function lineCompareCents(item) {
  const eff = _effectiveCompare(item);
  if (eff) return eff * item.quantity;
  if (item.original_line_price > item.final_line_price) return item.original_line_price;
  return item.final_line_price;
}

function computeCartCompareAndSaved(cart) {
  const items = cart.items || [];
  const bundleGroups = new Map();
  const standalone = [];

  items.forEach((item) => {
    const bundleId = cartItemProp(item, '_bundle_id');
    if (!bundleId) {
      standalone.push(item);
      return;
    }
    if (!bundleGroups.has(bundleId)) bundleGroups.set(bundleId, []);
    bundleGroups.get(bundleId).push(item);
  });

  let compareTotal = 0;
  bundleGroups.forEach((groupItems) => {
    const first = groupItems[0];
    const bundleQty = parseInt(cartItemProp(first, '_bundle_qty') || '0', 10) || 0;
    const bundleCompare = bundleCompareCentsForGroup(first, bundleQty);
    const finalTotal = groupItems.reduce((sum, i) => sum + i.final_line_price, 0);
    if (bundleCompare > finalTotal) {
      compareTotal += bundleCompare;
    } else {
      compareTotal += finalTotal;
    }
  });
  standalone.forEach((item) => {
    compareTotal += lineCompareCents(item);
  });

  const finalTotal = cart.total_price || 0;
  const saved = compareTotal > finalTotal ? compareTotal - finalTotal : 0;
  return { compareTotal, finalTotal, saved };
}

function cartItemProp(item, key) {
  const p = item.properties;
  if (!p) return '';
  if (typeof p === 'object' && !Array.isArray(p)) return p[key] || '';
  if (Array.isArray(p)) {
    const row = p.find((e) => e.name === key || e.first === key || e[0] === key);
    return row?.value ?? row?.[1] ?? '';
  }
  return '';
}

function getTogglePref(key, defaultValue) {
  const value = window.localStorage.getItem(key);
  if (value === null) return defaultValue;
  return value === 'true';
}

function findLineByHandle(items, handle) {
  return (items || []).find((line) => line.handle === handle);
}

function hasSilkTrimInCart(items) {
  return (items || []).some((line) => line.handle === CART_SILKTRIM_HANDLE);
}

function normalizeColorKey(value) {
  return String(value || '')
    .toLowerCase()
    .replace(/å/g, 'a')
    .replace(/ä/g, 'a')
    .replace(/ö/g, 'o')
    .replace(/\s+/g, '');
}

function getPreferredSilkTrimColorKey(items) {
  const silktrimLines = (items || []).filter((line) => line.handle === CART_SILKTRIM_HANDLE);
  if (!silktrimLines.length) {
    return normalizeColorKey(window.localStorage.getItem(CART_LAST_SILKTRIM_COLOR_KEY) || '');
  }
  const silktrimLine = silktrimLines[silktrimLines.length - 1];

  const bundlePrimaryColor = cartItemProp(silktrimLine, '_bundle_primary_color');
  if (bundlePrimaryColor) {
    const normalized = normalizeColorKey(bundlePrimaryColor);
    if (normalized) window.localStorage.setItem(CART_LAST_SILKTRIM_COLOR_KEY, normalized);
    return normalized;
  }

  if (Array.isArray(silktrimLine.options_with_values)) {
    const colorOpt = silktrimLine.options_with_values.find((opt) =>
      /farg|färg|color|colour/i.test(String(opt.name || ''))
    );
    if (colorOpt?.value) {
      const normalized = normalizeColorKey(colorOpt.value);
      if (normalized) window.localStorage.setItem(CART_LAST_SILKTRIM_COLOR_KEY, normalized);
      return normalized;
    }
  }

  if (Array.isArray(silktrimLine.variant_options) && silktrimLine.variant_options.length) {
    const firstOpt = silktrimLine.variant_options[0];
    if (firstOpt) return normalizeColorKey(firstOpt);
  }

  const mapped = CART_SILKTRIM_VARIANT_COLOR_BY_ID[String(silktrimLine.variant_id || silktrimLine.id)];
  if (mapped) {
    const normalized = normalizeColorKey(mapped);
    if (normalized) window.localStorage.setItem(CART_LAST_SILKTRIM_COLOR_KEY, normalized);
    return normalized;
  }

  const label =
    silktrimLine.variant_title && silktrimLine.variant_title !== 'Default Title'
      ? silktrimLine.variant_title.split('/')[0]
      : '';
  const normalized = normalizeColorKey(label);
  if (normalized) window.localStorage.setItem(CART_LAST_SILKTRIM_COLOR_KEY, normalized);
  return normalized;
}

function getPreferredTrimmerHeadsVariantId(items) {
  const colorKey = getPreferredSilkTrimColorKey(items);
  if (colorKey && CART_TRIMMER_HEADS_VARIANT_BY_COLOR[colorKey]) {
    return Number(CART_TRIMMER_HEADS_VARIANT_BY_COLOR[colorKey] || 0);
  }
  return CART_TRIMMER_HEADS_VARIANT_ID;
}

function hasCoreCartItems(items) {
  return (items || []).some((line) => line.handle !== CART_INSURANCE_HANDLE && line.handle !== CART_TRIMMER_HEADS_HANDLE);
}

function isAddonLine(item) {
  return item.handle === CART_INSURANCE_HANDLE || item.handle === CART_TRIMMER_HEADS_HANDLE;
}

function renderInsuranceAddon(cart) {
  const items = cart.items || [];
  const hasCore = hasCoreCartItems(items);
  const insuranceLine = findLineByHandle(items, CART_INSURANCE_HANDLE);
  const insurancePrice = insuranceLine
    ? formatMoney(insuranceLine.final_price)
    : formatMoney(CART_INSURANCE_PRICE);
  if (hasCore && CART_INSURANCE_VARIANT_ID) {
    return `
      <div class="cart-drawer__insurance" data-addon-card data-addon-type="insurance">
        <div class="cart-drawer__insurance-row">
          <label class="cart-drawer__insurance-toggle">
            <input type="checkbox" data-addon-toggle="insurance" ${insuranceLine ? 'checked' : ''}>
            <span aria-hidden="true"></span>
          </label>
          <span class="cart-drawer__insurance-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" focusable="false" aria-hidden="true">${CART_SHIELD_SVG}</svg>
          </span>
          <div class="cart-drawer__insurance-copy">
            <strong>${escapeHTML(CART_INSURANCE_LABEL)}</strong>
            <span>${escapeHTML(insurancePrice)}</span>
          </div>
        </div>
      </div>
    `;
  }
  return '';
}

function renderTrimmerHeadsInlineAddon(cart) {
  const items = cart.items || [];
  const hasSilkTrim = hasSilkTrimInCart(items);
  const trimmerHeadsLine = findLineByHandle(items, CART_TRIMMER_HEADS_HANDLE);
  const headsCfg = cartAddonConfig.trimmerHeads || {};
  const preferredVariantId = getPreferredTrimmerHeadsVariantId(items);
  const wantsTrimmerHeads = getTogglePref(CART_PREF_TRIMMER_HEADS, false);
  if (!hasSilkTrim || !preferredVariantId) return '';

  const trimmerHeadsPrice = formatMoney(CART_TRIMMER_HEADS_PRICE);
  const trimmerHeadsCompare =
    headsCfg.compareAt && headsCfg.compareAt > (headsCfg.price || 0)
      ? formatMoney(headsCfg.compareAt)
      : '';
  const variantImage = CART_TRIMMER_HEADS_VARIANT_IMAGE_BY_ID[String(preferredVariantId)];
  const inlineImage = variantImage || headsCfg.image || '';
  const imageHtml = inlineImage
    ? `<img class="cart-item__img" src="${escapeHTML(inlineImage)}" alt="" width="80" height="80" loading="lazy">`
    : `<div class="cart-item__img cart-inline-addon__placeholder"></div>`;
  const colorKey = getPreferredSilkTrimColorKey(items);
  const variantLabel = colorKey
    ? `<div class="cart-inline-addon__variant">Färg: ${escapeHTML(colorKey.charAt(0).toUpperCase() + colorKey.slice(1))}</div>`
    : '';

  return `
    <div class="cart-item cart-inline-addon">
      ${imageHtml}
      <div>
        <div class="cart-item__title">${escapeHTML(CART_TRIMMER_HEADS_LABEL)}</div>
        ${variantLabel}
        <div class="cart-item__price-row">
          <span class="cart-item__price">${escapeHTML(trimmerHeadsPrice)}</span>
          ${trimmerHeadsCompare ? `<span class="cart-item__compare">${escapeHTML(trimmerHeadsCompare)}</span>` : ''}
        </div>
      </div>
      <label class="cart-drawer__brush-heads-toggle cart-inline-addon__toggle">
        <input type="checkbox" data-addon-toggle="trimmer-heads" ${wantsTrimmerHeads ? 'checked' : ''}>
        <span aria-hidden="true"></span>
      </label>
    </div>
  `;
}

function updateCartAddonsFooter(cart) {
  const html = renderInsuranceAddon(cart);
  // Only refresh drawer footer addons — cart page keeps Liquid-rendered markup
  document.querySelectorAll('.cart-drawer__footer [data-cart-addons-root]').forEach((el) => {
    el.innerHTML = html;
  });
}

function setAddonToggleBusy(isBusy) {
  document.querySelectorAll('[data-addon-toggle]').forEach((toggle) => {
    toggle.disabled = !!isBusy;
  });
}

async function setAddonLine(variantId, existingLine, enabled) {
  if (enabled && !existingLine) {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    });
    return true;
  }
  if (!enabled && existingLine) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: existingLine.key, quantity: 0 }),
    });
    return true;
  }
  return false;
}

async function reconcileCartAddons(cart) {
  if (cartAddonSyncInFlight) {
    cartAddonSyncPending = true;
    return;
  }
  const items = cart.items || [];
  const hasCore = hasCoreCartItems(items);
  const hasSilkTrim = hasSilkTrimInCart(items);
  const insuranceLine = findLineByHandle(items, CART_INSURANCE_HANDLE);
  const trimmerHeadsLine = findLineByHandle(items, CART_TRIMMER_HEADS_HANDLE);
  const wantsInsurance = getTogglePref(CART_PREF_INSURANCE, true);
  const wantsTrimmerHeads = getTogglePref(CART_PREF_TRIMMER_HEADS, false);

  let changed = false;
  cartAddonSyncInFlight = true;
  try {
    const insuranceShouldBeOn = hasCore && wantsInsurance;
    if (CART_INSURANCE_VARIANT_ID) {
      changed = (await setAddonLine(CART_INSURANCE_VARIANT_ID, insuranceLine, insuranceShouldBeOn)) || changed;
    }

    const trimmerHeadsShouldBeOn = hasSilkTrim && wantsTrimmerHeads;
    const preferredTrimmerHeadsVariantId = getPreferredTrimmerHeadsVariantId(items);
    if (preferredTrimmerHeadsVariantId && trimmerHeadsShouldBeOn && trimmerHeadsLine && Number(trimmerHeadsLine.variant_id) !== preferredTrimmerHeadsVariantId) {
      await setAddonLine(preferredTrimmerHeadsVariantId, trimmerHeadsLine, false);
      await setAddonLine(preferredTrimmerHeadsVariantId, null, true);
      changed = true;
    } else if (preferredTrimmerHeadsVariantId) {
      changed = (await setAddonLine(preferredTrimmerHeadsVariantId, trimmerHeadsLine, trimmerHeadsShouldBeOn)) || changed;
    }
  } catch (e) {
    // no-op
  } finally {
    cartAddonSyncInFlight = false;
  }

  if (cartAddonSyncPending) {
    cartAddonSyncPending = false;
    fetchCart();
    return;
  }

  if (changed) {
    if (document.querySelector('.zarina-cart')) {
      window.location.reload();
      return;
    }
    fetchCart();
  }
}

function renderSingleCartItem(item) {
  const comparePerUnit = _effectiveCompare(item);
  const compareLine = comparePerUnit
    ? comparePerUnit * item.quantity
    : (item.original_line_price > item.final_line_price ? item.original_line_price : null);
  const onSale = compareLine && compareLine > item.final_line_price;
  const variantLabel =
    item.variant_title && item.variant_title !== 'Default Title'
      ? item.variant_title.replace(/^Standard\s*\/\s*/i, '').replace(/^I paket\s*\/\s*/i, '')
      : '';
  return `
    <div class="cart-item" data-key="${escapeHTML(item.key)}">
      ${item.image ? `<img class="cart-item__img" src="${escapeHTML(item.image)}" alt="">` : ''}
      <div>
        <div class="cart-item__title">${escapeHTML(item.product_title)}</div>
        ${variantLabel ? `<div style="font-size:12px;color:#888">${escapeHTML(variantLabel)}</div>` : ''}
        <div class="cart-item__price-row">
          <span class="cart-item__price">${formatMoney(item.final_line_price)}</span>
          ${onSale ? `<span class="cart-item__compare">${formatMoney(compareLine)}</span>` : ''}
        </div>
        <div class="cart-item__qty">
          <button type="button" data-cart-qty="${item.quantity - 1}" aria-label="Minska antal">−</button>
          <span>${item.quantity}</span>
          <button type="button" data-cart-qty="${item.quantity + 1}" aria-label="Öka antal">+</button>
        </div>
      </div>
      <button type="button" class="cart-item__remove" data-cart-remove aria-label="Ta bort">×</button>
    </div>
  `;
}

function renderBundleCartGroup(bundleId, groupItems) {
  const first = groupItems[0];
  const title = cartItemProp(first, '_bundle_title') || 'Paket';
  const image = cartItemProp(first, '_bundle_image');
  const total = groupItems.reduce((sum, i) => sum + i.final_line_price, 0);
  const bundleQty = parseInt(cartItemProp(first, '_bundle_qty') || '0', 10) || 0;
  const compareLine = bundleCompareCentsForGroup(first, bundleQty);
  const onSale = compareLine > total;
  const keys = groupItems.map((i) => i.key);
  const lines = groupItems
    .map((i) => {
      let label = i.product_title || '';
      const v = i.variant_title && i.variant_title !== 'Default Title' ? i.variant_title : '';
      if (v) label += ` (${v.replace(/^Standard\s*\/\s*/i, '')})`;
      return escapeHTML(label);
    })
    .join(' · ');
  return `
    <div class="cart-bundle" data-bundle-id="${escapeHTML(bundleId)}" data-bundle-keys="${escapeHTML(keys.join(','))}">
      ${image ? `<img class="cart-item__img cart-bundle__img" src="${escapeHTML(image)}" alt="" loading="lazy">` : ''}
      <div class="cart-bundle__body">
        <div class="cart-item__title">${escapeHTML(title)}</div>
        <div class="cart-bundle__lines">${lines}</div>
        <div class="cart-item__price-row">
          <span class="cart-item__price">${formatMoney(total)}</span>
          ${onSale ? `<span class="cart-item__compare">${formatMoney(compareLine)}</span>` : ''}
        </div>
      </div>
      <button type="button" class="cart-item__remove" data-bundle-remove aria-label="Ta bort paket">×</button>
    </div>
  `;
}

function updateCartUI(cart) {
  const count = cart.item_count || 0;
  if (cartCountEl) {
    cartCountEl.textContent = count;
    cartCountEl.classList.toggle('visible', count > 0);
  }

  const items = cart.items || [];
  const visibleItems = items.filter((item) => !isAddonLine(item));

  const body = document.querySelector('.cart-drawer__body');
  const subtotalEl = document.getElementById('cartSubtotalAmount');
  const compareAmt = document.getElementById('cartCompareAmount');
  const { compareTotal, finalTotal, saved } = computeCartCompareAndSaved(cart);
  if (subtotalEl) subtotalEl.textContent = formatMoney(finalTotal);

  if (compareAmt) {
    if (saved > 0) {
      compareAmt.hidden = false;
      compareAmt.textContent = formatMoney(compareTotal);
    } else {
      compareAmt.hidden = true;
    }
  }

  const savedEl = document.getElementById('cartSaved');
  const savedAmt = document.getElementById('cartSavedAmount');
  if (savedEl) {
    if (saved > 0) {
      savedEl.hidden = false;
      if (savedAmt) savedAmt.textContent = formatMoney(saved);
    } else {
      savedEl.hidden = true;
    }
  }

  updateCartAddonsFooter(cart);

  if (!body) {
    void reconcileCartAddons(cart);
    return;
  }
  if (visibleItems.length === 0) {
    body.innerHTML = `<div class="cart-drawer__empty"><p>Din varukorg är tom</p><a href="${escapeHTML(allProductsUrl)}" class="cart-checkout-btn" style="display:inline-block;width:auto;padding:12px 24px;">Fortsätt handla</a></div>`;
    updateCartAddonsFooter({ items: [] });
    void reconcileCartAddons(cart);
    return;
  }
  const bundleGroups = new Map();
  const standalone = [];
  visibleItems.forEach((item) => {
    const bundleId = cartItemProp(item, '_bundle_id');
    if (!bundleId) {
      standalone.push(item);
      return;
    }
    if (!bundleGroups.has(bundleId)) bundleGroups.set(bundleId, []);
    bundleGroups.get(bundleId).push(item);
  });

  const html = [];
  bundleGroups.forEach((groupItems, bundleId) => {
    html.push(renderBundleCartGroup(bundleId, groupItems));
  });
  standalone.forEach((item) => html.push(renderSingleCartItem(item)));
  const trimmerInline = renderTrimmerHeadsInlineAddon(cart);
  if (trimmerInline) html.push(trimmerInline);
  body.innerHTML = html.join('');
  void reconcileCartAddons(cart);
}

function formatMoney(cents) {
  const currency = window.Shopify?.currency?.active || 'SEK';
  return (cents / 100).toLocaleString('sv-SE', { style: 'currency', currency });
}

function escapeHTML(value) {
  return String(value || '').replace(/[&<>"']/g, char => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  }[char]));
}

async function updateQty(id, qty) {
  if (qty < 0) qty = 0;
  try {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id, quantity: qty })
    });
    fetchCart();
  } catch(e) {}
}

async function removeItem(id) {
  await updateQty(id, 0);
}

document.querySelector('.cart-drawer__body')?.addEventListener('click', async (event) => {
  const bundleEl = event.target.closest('.cart-bundle');
  if (bundleEl && event.target.matches('[data-bundle-remove]')) {
    const keys = (bundleEl.dataset.bundleKeys || '').split(',').filter(Boolean);
    for (const key of keys) await updateQty(key, 0);
    return;
  }
  const item = event.target.closest('.cart-item');
  if (!item) return;
  const key = item.dataset.key;
  if (event.target.matches('[data-cart-remove]')) {
    removeItem(key);
    return;
  }
  const qtyButton = event.target.closest('[data-cart-qty]');
  if (qtyButton) updateQty(key, parseInt(qtyButton.dataset.cartQty, 10));
});

function initCartAddonListeners() {
  if (initCartAddonListeners._done) return;
  initCartAddonListeners._done = true;

  document.addEventListener('change', (event) => {
    const toggle = event.target.closest('[data-addon-toggle]');
    if (!toggle) return;

    const type = toggle.dataset.addonToggle;
    if (type === 'insurance') {
      window.localStorage.setItem(CART_PREF_INSURANCE, toggle.checked ? 'true' : 'false');
    }
    if (type === 'trimmer-heads') {
      window.localStorage.setItem(CART_PREF_TRIMMER_HEADS, toggle.checked ? 'true' : 'false');
    }
    setAddonToggleBusy(true);
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => reconcileCartAddons(cart))
      .then(() => fetchCart())
      .catch(() => fetchCart())
      .finally(() => {
        setAddonToggleBusy(false);
      });
  });
}

initCartAddonListeners();

// URGENCY TIMER (persistent på tvers av sidebytter)
let urgencyTimerInterval = null;
const URGENCY_DURATION = 420; // 7 min
const URGENCY_KEY = 'zh_urgency_end';

function _urgencyFormat(secs) {
  const m = Math.floor(secs / 60);
  const s = secs % 60;
  return `${m}:${s.toString().padStart(2, '0')}`;
}

function _urgencyRender(secs) {
  const timerEl = document.getElementById('urgencyTimer');
  const countEl = document.getElementById('urgencyTimerCount');
  const cartTimerEl = document.getElementById('cartUrgencyTimer');
  const cartCountEl = document.getElementById('cartUrgencyCount');
  timerEl?.classList.add('visible');
  cartTimerEl?.classList.add('visible');
  const t = _urgencyFormat(secs);
  if (countEl) countEl.textContent = t;
  if (cartCountEl) cartCountEl.textContent = t;
  if (secs <= 60) {
    timerEl?.classList.add('urgency-timer--urgent');
    cartTimerEl?.classList.add('urgency-timer--urgent');
  } else {
    timerEl?.classList.remove('urgency-timer--urgent');
    cartTimerEl?.classList.remove('urgency-timer--urgent');
  }
}

function _urgencyExpire() {
  clearInterval(urgencyTimerInterval);
  urgencyTimerInterval = null;
  localStorage.removeItem(URGENCY_KEY);
  document.getElementById('urgencyTimer')?.classList.remove('visible');
  document.getElementById('cartUrgencyTimer')?.classList.remove('visible');
  try {
    sessionStorage.removeItem('zarina-slutfor-kopet-v1');
  } catch (e) {
    /* ignore */
  }
  fetch('/cart/clear.js', { method: 'POST' })
    .then(() => fetchCart())
    .then(() => {
      sessionStorage.removeItem('insurance_opted_out');
      showToast('Reservasjonen din utløp – handlekurven er nullstilt.');
      closeCart();
    })
    .catch(() => {});
}

function _urgencyTick() {
  const end = parseInt(localStorage.getItem(URGENCY_KEY) || '0', 10);
  if (!end) return;
  const secs = Math.max(0, Math.round((end - Date.now()) / 1000));
  if (secs <= 0) { _urgencyExpire(); return; }
  _urgencyRender(secs);
}

function startUrgencyTimer(forceReset) {
  // Bare reset hvis ingen aktiv timer eller eksplisitt forced
  const existing = parseInt(localStorage.getItem(URGENCY_KEY) || '0', 10);
  const now = Date.now();
  if (forceReset || !existing || existing <= now) {
    localStorage.setItem(URGENCY_KEY, String(now + URGENCY_DURATION * 1000));
  }
  clearInterval(urgencyTimerInterval);
  _urgencyTick();
  urgencyTimerInterval = setInterval(_urgencyTick, 1000);
}

function stopUrgencyTimer() {
  clearInterval(urgencyTimerInterval);
  urgencyTimerInterval = null;
  localStorage.removeItem(URGENCY_KEY);
  document.getElementById('urgencyTimer')?.classList.remove('visible');
  document.getElementById('cartUrgencyTimer')?.classList.remove('visible');
}

function hasPendingCompletePurchase() {
  try {
    const raw = sessionStorage.getItem('zarina-slutfor-kopet-v1');
    if (!raw) return false;
    const data = JSON.parse(raw);
    return !!(data && data.primary);
  } catch (e) {
    return false;
  }
}

// Resume timer ved sideinnlasting hvis kurv har varer ELLER slutför-köpet er i gang
document.addEventListener('DOMContentLoaded', () => {
  const end = parseInt(localStorage.getItem(URGENCY_KEY) || '0', 10);
  if (end && end > Date.now()) {
    const resume = () => {
      clearInterval(urgencyTimerInterval);
      _urgencyTick();
      urgencyTimerInterval = setInterval(_urgencyTick, 1000);
    };
    if (hasPendingCompletePurchase()) {
      resume();
      return;
    }
    fetch('/cart.js').then(r => r.json()).then(cart => {
      if (cart.item_count > 0) resume();
      else stopUrgencyTimer();
    }).catch(() => {});
  }
});

// Resume også når faner blir aktive igjen (mobil bakgrunn-throttling)
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') {
    const end = parseInt(localStorage.getItem(URGENCY_KEY) || '0', 10);
    if (end && end > Date.now() && !urgencyTimerInterval) {
      _urgencyTick();
      urgencyTimerInterval = setInterval(_urgencyTick, 1000);
    } else if (end && end <= Date.now()) {
      _urgencyExpire();
    }
  }
});

// FLY-TO-CART ANIMATION (desktop only)
const _isMobile = () => window.matchMedia('(max-width: 768px)').matches;
const _reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function flyToCart() {
  if (_isMobile() || _reduceMotion()) return;
  const productImg = document.querySelector('.product-gallery__main img, #HomeMainImg img, #MainProductImage');
  const cartIcon = document.querySelector('.cart-btn');
  if (!productImg || !cartIcon) return;

  const startRect = productImg.getBoundingClientRect();
  const endRect = cartIcon.getBoundingClientRect();
  const dx = (endRect.left + endRect.width/2) - (startRect.left + startRect.width/2);
  const dy = (endRect.top + endRect.height/2) - (startRect.top + startRect.height/2);
  const scale = 40 / Math.max(startRect.width, 1);

  const clone = productImg.cloneNode(true);
  clone.removeAttribute('id');
  clone.style.cssText = `
    position:fixed; left:${startRect.left}px; top:${startRect.top}px;
    width:${startRect.width}px; height:${startRect.height}px;
    border-radius:50%; object-fit:cover; z-index:9999;
    pointer-events:none; will-change: transform, opacity;
    transition: transform 0.65s cubic-bezier(0.5,-0.2,0.7,0.4), opacity 0.65s ease;
    box-shadow: 0 8px 24px rgba(0,0,0,0.2);
  `;
  document.body.appendChild(clone);

  requestAnimationFrame(() => {
    clone.style.transform = `translate(${dx}px, ${dy}px) scale(${scale})`;
    clone.style.opacity = '0.4';
  });

  setTimeout(() => {
    cartIcon.classList.add('cart-btn--bump');
    setTimeout(() => cartIcon.classList.remove('cart-btn--bump'), 400);
    clone.remove();
  }, 650);
}

// ADD TO CART
function getAtcLabelEl(btn) {
  return btn.querySelector('.product-info__atc-label');
}

function setAtcButtonText(btn, text) {
  const label = getAtcLabelEl(btn);
  if (label) {
    label.textContent = text;
    return;
  }
  btn.textContent = text;
}

function storeAtcButtonText(btn) {
  if (!btn.dataset.originalText) {
    btn.dataset.originalText = getAtcLabelEl(btn)
      ? getAtcLabelEl(btn).textContent.trim()
      : btn.textContent.trim();
  }
}

function restoreAtcButtonText(btn) {
  const fallback = btn.dataset.originalText || 'Lägg i varukorg';
  setAtcButtonText(btn, fallback);
}

async function addToCart(variantId, qty = 1, opts = {}) {
  const goCheckout = !!opts.checkout;
  const buttons = document.querySelectorAll('[data-add-to-cart], .sticky-atc__btn');
  buttons.forEach(b => {
    const isSticky = b.classList.contains('sticky-atc__btn');
    b.classList.add('is-loading');
    if (isSticky) {
      const label = b.querySelector('.sticky-atc__label');
      const sep   = b.querySelector('.sticky-atc__sep');
      const price = b.querySelector('.sticky-atc__price');
      if (label) label.textContent = goCheckout ? 'Till kassan...' : 'Legger til...';
      if (sep)   sep.style.display = 'none';
      if (price) price.style.display = 'none';
    } else {
      storeAtcButtonText(b);
      setAtcButtonText(b, goCheckout ? 'Till kassan...' : 'Legger til...');
    }
    b.disabled = true;
  });

  const restoreButtons = () => buttons.forEach(b => {
    b.classList.remove('is-loading');
    const isSticky = b.classList.contains('sticky-atc__btn');
    if (isSticky) {
      const label = b.querySelector('.sticky-atc__label');
      const sep   = b.querySelector('.sticky-atc__sep');
      const price = b.querySelector('.sticky-atc__price');
      if (label) label.textContent = b.dataset.originalText || 'Lägg i varukorg';
      if (sep)   sep.style.display = '';
      if (price) price.style.display = '';
    } else {
      restoreAtcButtonText(b);
    }
    b.disabled = false;
  });

  const id = parseInt(variantId, 10);
  const compareProps = buildLineItemCompareProps(id);

  try {
    if (window.ZarinaAttribution) await window.ZarinaAttribution.applyToCart();
    const payload = { id, quantity: qty };
    if (compareProps) payload.properties = compareProps;
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
    if (!res.ok) throw new Error('Add failed');
    if (goCheckout) {
      window.location.href = '/checkout';
      return;
    }
    openCart();
    await fetchCart();
    restoreButtons();
    startUrgencyTimer();
  } catch(e) {
    restoreButtons();
    showToast('Noe gikk galt. Prøv igjen.');
  }
}

/** Pixel IDs (public) — same as Shopify Web Pixel apps on zarina.se */
const ZARINA_META_PIXEL_ID = '1006999808540165';
const ZARINA_TIKTOK_PIXEL_CODE = 'D8EHM0RC77U8UFHBQ9M0';

function centsToMajor(cents) {
  const n = Number(cents);
  if (!Number.isFinite(n)) return 0;
  return Math.round(n) / 100;
}

function ensureMetaPixel() {
  if (window.__zarinaFbqReady) return window.__zarinaFbqReady;
  window.__zarinaFbqReady = new Promise((resolve) => {
    const f = window;
    const b = document;
    if (!f.fbq) {
      const n = (f.fbq = function () {
        if (n.callMethod) n.callMethod.apply(n, arguments);
        else n.queue.push(arguments);
      });
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = b.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      t.onload = () => resolve();
      t.onerror = () => resolve();
      const s = b.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(t, s);
    } else {
      resolve();
    }
    if (!window.__zarinaFbqInited) {
      // Init only — do not fire PageView (Shopify Web Pixel already does)
      f.fbq('init', ZARINA_META_PIXEL_ID);
      window.__zarinaFbqInited = true;
    }
    // Resolve quickly even if script is still loading (queue holds track calls)
    setTimeout(resolve, 0);
  });
  return window.__zarinaFbqReady;
}

function ensureTikTokPixel() {
  if (window.__zarinaTtqReady) return window.__zarinaTtqReady;
  window.__zarinaTtqReady = new Promise((resolve) => {
    const w = window;
    const d = document;
    const t = 'ttq';
    w.TiktokAnalyticsObject = t;
    const ttq = (w[t] = w[t] || []);
    ttq.methods = [
      'page',
      'track',
      'identify',
      'instances',
      'debug',
      'on',
      'off',
      'once',
      'ready',
      'alias',
      'group',
      'enableCookie',
      'disableCookie',
      'holdConsent',
      'revokeConsent',
      'grantConsent',
    ];
    ttq.setAndDefer = function (obj, method) {
      obj[method] = function () {
        obj.push([method].concat(Array.prototype.slice.call(arguments, 0)));
      };
    };
    for (let i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
    ttq.instance = function (id) {
      const inst = (ttq._i[id] = ttq._i[id] || []);
      for (let j = 0; j < ttq.methods.length; j++) ttq.setAndDefer(inst, ttq.methods[j]);
      return inst;
    };
    ttq.load = function (id) {
      const url = 'https://analytics.tiktok.com/i18n/pixel/events.js';
      ttq._i = ttq._i || {};
      ttq._i[id] = [];
      ttq._t = ttq._t || {};
      ttq._t[id] = +new Date();
      ttq._o = ttq._o || {};
      const script = d.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = `${url}?sdkid=${id}&lib=${t}`;
      script.onload = () => resolve();
      script.onerror = () => resolve();
      const first = d.getElementsByTagName('script')[0];
      first.parentNode.insertBefore(script, first);
    };
    if (!window.__zarinaTtqInited) {
      if (!d.querySelector('script[src*="analytics.tiktok.com/i18n/pixel/events.js"]')) {
        ttq.load(ZARINA_TIKTOK_PIXEL_CODE);
      }
      window.__zarinaTtqInited = true;
    }
    // Queue track calls immediately; script flushes when ready
    setTimeout(resolve, 0);
  });
  return window.__zarinaTtqReady;
}

function metaAddToCartBeacon(payload) {
  try {
    const params = new URLSearchParams();
    params.set('id', ZARINA_META_PIXEL_ID);
    params.set('ev', 'AddToCart');
    params.set('noscript', '1');
    params.set('eid', payload.eventId);
    params.set('dl', payload.eventSourceUrl);
    params.set('cd[value]', String(payload.value));
    params.set('cd[currency]', payload.currency);
    params.set('cd[content_type]', 'product');
    params.set('cd[content_ids]', JSON.stringify(payload.contentIds));
    params.set('cd[content_name]', payload.contentName || '');
    params.set('cd[num_items]', String(payload.quantity || 1));
    const img = new Image();
    img.src = `https://www.facebook.com/tr?${params.toString()}`;
  } catch (e) {
    /* ignore */
  }
}

/**
 * AddToCart when customer clicks Köp → Slutför köpet (cart is still empty).
 * Meta + TikTok browser events for the selected product/pack.
 */
function trackVirtualAddToCart({ catalog, primary, items }) {
  const qty = Number(primary?.qty || 1) || 1;
  const variantId = Number(items?.[0]?.id || 0) || 0;
  const productId = Number(catalog?.productId || 0) || 0;
  const valueCents = Number(catalog?.prices?.[qty] ?? catalog?.prices?.[1] ?? 0) || 0;
  const value = centsToMajor(valueCents);
  const currency = 'SEK';
  const contentName = catalog?.labels?.[qty] || catalog?.productTitle || 'Product';
  const contentIds = [String(productId || variantId)].filter(Boolean);
  const eventId = `atc-${catalog?.productKey || 'product'}-${variantId || 'x'}-${Date.now()}`;
  const eventSourceUrl = window.location.href;
  const payload = {
    eventId,
    value,
    currency,
    contentIds,
    contentName,
    quantity: 1,
    productId,
    variantId,
    productHandle: catalog?.productHandle || '',
    productTitle: catalog?.productTitle || '',
    packQty: qty,
    color: primary?.color || '',
    eventSourceUrl,
  };

  try {
    if (window.Shopify?.analytics?.publish) {
      window.Shopify.analytics.publish('zarina:add_to_cart', payload);
    }
  } catch (e) {
    /* ignore */
  }

  // Beacon first so Meta survives fast redirect
  metaAddToCartBeacon(payload);

  const metaPromise = ensureMetaPixel()
    .then(() => {
      if (typeof window.fbq !== 'function') return;
      window.fbq(
        'track',
        'AddToCart',
        {
          content_ids: contentIds,
          content_type: 'product',
          content_name: contentName,
          value,
          currency,
          num_items: 1,
        },
        { eventID: eventId }
      );
    })
    .catch(() => {});

  const tiktokPromise = ensureTikTokPixel()
    .then(() => {
      if (!window.ttq || typeof window.ttq.track !== 'function') return;
      window.ttq.track(
        'AddToCart',
        {
          contents: [
            {
              content_id: String(productId || variantId),
              content_type: 'product',
              content_name: contentName,
              quantity: 1,
              price: value,
            },
          ],
          value,
          currency,
        },
        { event_id: eventId }
      );
    })
    .catch(() => {});

  return Promise.all([metaPromise, tiktokPromise]);
}

function saveCompletePurchaseAndGo() {
  const catalog = window._COMPLETE_PURCHASE_CONFIG;
  if (!catalog) return false;

  let items = [];
  try {
    items = typeof window._getBundleItems === 'function' ? window._getBundleItems() : [];
  } catch (e) {
    items = [];
  }
  if (!items?.length) {
    const btn = document.querySelector('[data-add-to-cart][data-complete-purchase]');
    const id = parseInt(btn?.dataset.variantId || '0', 10);
    if (id) items = [{ id, quantity: 1 }];
  }
  if (!items?.length) return false;

  let meta = null;
  let qty = 1;
  let colors = [];
  try {
    meta = typeof window._getBundleMeta === 'function' ? window._getBundleMeta() : null;
  } catch (e) {
    meta = null;
  }
  try {
    qty = typeof window._getCurrentQty === 'function' ? window._getCurrentQty() : 1;
  } catch (e) {
    qty = 1;
  }
  try {
    colors = typeof window._getBundleColors === 'function' ? window._getBundleColors() : [];
  } catch (e) {
    colors = [];
  }
  let color = (meta && meta.primaryColor) || colors[0] || '';
  if (!color) {
    const activeOpt = document.querySelector('.product-option__value.active');
    color = activeOpt?.dataset.optionValue || '';
  }

  // Prefer dedicated pack/list images (theme assets) — never gallery media
  const packQty = catalog.features?.packages ? qty : 1;
  let image = '';
  const colorImgs = catalog.colorImages || {};
  if (colorImgs[color]) image = colorImgs[color];
  if (!image) {
    const want = normalizeColorKey(color);
    for (const [name, url] of Object.entries(colorImgs)) {
      if (normalizeColorKey(name) === want) {
        image = url;
        break;
      }
    }
  }
  if (!image) {
    const imgs = catalog.bundleImages?.[packQty] || catalog.bundleImages?.[1] || {};
    const want = normalizeColorKey(color);
    if (want.includes('rosa') || want.includes('pink')) image = imgs.rosa || '';
    else if (want.includes('svart') || want.includes('black')) image = imgs.svart || '';
    else if (want.includes('bla') || want.includes('blue')) image = imgs.bla || '';
    if (!image) image = imgs.default || '';
  }
  if (!image) image = (meta && meta.image) || catalog.defaultImage || '';

  const primary = {
    qty: packQty,
    color,
    image,
    items,
    meta,
  };

  const payload = {
    catalog,
    primary,
    primaryHeads: false,
    friends: [],
    insurance: true,
  };
  try {
    sessionStorage.setItem('zarina-slutfor-kopet-v1', JSON.stringify(payload));
  } catch (e) {
    /* ignore */
  }

  // Same reservation countdown as classic ATC (visible on Slutför köpet)
  if (typeof startUrgencyTimer === 'function') startUrgencyTimer();

  // ATC on Köp (before redirect) — wait briefly so Meta/TikTok can flush
  const go = () => {
    window.location.assign('/pages/slutfor-kopet');
  };
  Promise.race([
    trackVirtualAddToCart({ catalog, primary, items }),
    new Promise((resolve) => setTimeout(resolve, 450)),
  ]).then(go, go);

  return true;
}

// ATC BUTTONS — bundle-aware: legger til 1 av hver valgt farge for current bundle
document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
  btn.addEventListener('click', function(e) {
    e.preventDefault();
    // Complete-purchase flow (SilkTrim, Swift Heat Go, …)
    if (this.hasAttribute('data-complete-purchase')) {
      if (saveCompletePurchaseAndGo()) return;
    }
    // Hvis vi har en bundle-state, bruk den; ellers fall back på enkel variant
    if (typeof window._getBundleItems === 'function') {
      const items = window._getBundleItems();
      if (items && items.length) {
        const meta = typeof window._getBundleMeta === 'function' ? window._getBundleMeta() : null;
        addBundleToCart(items, meta);
        return;
      }
    }
    const variantId = this.dataset.variantId || this.closest('[data-variant-id]')?.dataset.variantId;
    const qty = (typeof window._getCurrentQty === 'function') ? window._getCurrentQty() : 1;
    const checkout = this.hasAttribute('data-buy-now');
    if (variantId) addToCart(parseInt(variantId), qty, { checkout });
  });
});

async function addBundleToCart(items, bundleMeta) {
  const buttons = document.querySelectorAll('[data-add-to-cart], .sticky-atc__btn');
  buttons.forEach(b => {
    b.classList.add('is-loading');
    const isSticky = b.classList.contains('sticky-atc__btn');
    if (isSticky) {
      const label = b.querySelector('.sticky-atc__label');
      const sep   = b.querySelector('.sticky-atc__sep');
      const price = b.querySelector('.sticky-atc__price');
      if (label) label.textContent = 'Legger til...';
      if (sep)   sep.style.display = 'none';
      if (price) price.style.display = 'none';
    } else {
      storeAtcButtonText(b);
      setAtcButtonText(b, 'Legger til...');
    }
    b.disabled = true;
  });
  const restoreButtons = () => buttons.forEach(b => {
    b.classList.remove('is-loading');
    const isSticky = b.classList.contains('sticky-atc__btn');
    if (isSticky) {
      const label = b.querySelector('.sticky-atc__label');
      const sep   = b.querySelector('.sticky-atc__sep');
      const price = b.querySelector('.sticky-atc__price');
      if (label) label.textContent = b.dataset.originalText || 'Lägg i varukorg';
      if (sep)   sep.style.display = '';
      if (price) price.style.display = '';
    } else {
      restoreAtcButtonText(b);
    }
    b.disabled = false;
  });

  try {
    if (window.ZarinaAttribution) await window.ZarinaAttribution.applyToCart();
    // Slå sammen identiske varianter til quantity
    const bundleCompare = bundleMeta ? bundleCompareCents(bundleMeta.qty) : 0;
    if (bundleMeta?.primaryColor) {
      window.localStorage.setItem(CART_LAST_SILKTRIM_COLOR_KEY, normalizeColorKey(bundleMeta.primaryColor));
    }
    const props = bundleMeta
      ? {
          _bundle_id: bundleMeta.id,
          _bundle_title: bundleMeta.title,
          _bundle_image: bundleMeta.image || '',
          _bundle_qty: String(bundleMeta.qty || ''),
          _bundle_primary_color: bundleMeta.primaryColor || '',
          _bundle_compare_cents: String(bundleCompare),
        }
      : null;
    const payload = {
      items: items.map((it) => ({
        id: parseInt(it.id, 10),
        quantity: it.quantity || 1,
        properties: props,
      })),
    };
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
    if (!res.ok) throw new Error('Add failed');
    openCart();
    await fetchCart();
    restoreButtons();
    startUrgencyTimer();
  } catch(e) {
    restoreButtons();
    showToast('Noe gikk galt. Prøv igjen.');
  }
}

// VARIANT MANAGER (pakke + farge)
(function() {
  const dataEl = document.getElementById('ProductVariantData');
  if (!dataEl) return;
  let variants;
  try { variants = JSON.parse(dataEl.textContent); } catch(e) { return; }
  if (!variants.length) return;
  registerVariantCompareFromVariants(variants);

  const isStandardPage = !!document.querySelector('.product-page--standard');
  if (isStandardPage) {
    function getSelectedOptionsArray() {
      const maxIdx = Math.max(
        ...[...document.querySelectorAll('.product-option')].map(el =>
          parseInt(el.dataset.optionIndex, 10)
        ),
        -1
      );
      const arr = [];
      document.querySelectorAll('.product-option').forEach(fieldset => {
        const idx = parseInt(fieldset.dataset.optionIndex, 10);
        const active =
          fieldset.querySelector('.product-option__value.active:not([disabled])') ||
          fieldset.querySelector('.product-option__value:not([disabled])');
        arr[idx] = active?.dataset.optionValue || '';
      });
      const defaults = window._STANDARD_DEFAULT_OPTIONS || {};
      Object.keys(defaults).forEach(k => {
        arr[parseInt(k, 10)] = defaults[k];
      });
      return arr;
    }

    function findStandardVariant() {
      const selected = getSelectedOptionsArray();
      return (
        variants.find(v => {
          const opts = v.options || [];
          return selected.every((sel, i) => !sel || opts[i] === sel);
        }) ||
        variants.find(v => v.available) ||
        variants[0]
      );
    }

    function updateStandardUI() {
      const v = findStandardVariant();
      if (!v) return;
      document.querySelectorAll('[data-add-to-cart], .sticky-atc__btn').forEach(b => {
        b.dataset.variantId = v.id;
      });
      const hiddenInput = document.querySelector('form input[name="id"]');
      if (hiddenInput) hiddenInput.value = v.id;

      const mainPrice = document.querySelector('.product-info__price');
      let mainCompare = document.querySelector('.product-info__compare');
      let mainBadge = document.querySelector('.product-info__badge');
      // Ensure compare + badge nodes exist (needed when first paint had no sale)
      const priceRow = document.querySelector('.product-info__prices');
      if (priceRow && v.compare) {
        if (!mainCompare) {
          mainCompare = document.createElement('span');
          mainCompare.className = 'product-info__compare';
          priceRow.appendChild(mainCompare);
        }
        if (!mainBadge) {
          mainBadge = document.createElement('span');
          mainBadge.className = 'product-info__badge';
          priceRow.appendChild(mainBadge);
        }
      }
      if (mainPrice) mainPrice.textContent = v.price;
      if (mainCompare) {
        if (v.compare) {
          mainCompare.textContent = v.compare;
          mainCompare.style.display = '';
        } else {
          mainCompare.style.display = 'none';
        }
      }
      if (mainBadge) {
        if (v.compare && v.price) {
          const p = parseMoneyMajor(v.price);
          const c = parseMoneyMajor(v.compare);
          if (c > p) {
            mainBadge.textContent = '−' + Math.round((1 - p / c) * 100) + '%';
            mainBadge.style.display = '';
          } else {
            mainBadge.style.display = 'none';
          }
        } else {
          mainBadge.style.display = 'none';
        }
      }
      const stickyPrice = document.getElementById('stickyAtcPrice');
      if (stickyPrice) stickyPrice.textContent = v.price;
      const shAtcPrice = document.getElementById('shAtcPrice');
      if (shAtcPrice) shAtcPrice.textContent = v.price;

      if (document.querySelector('.product-page--swiftheat')) {
        updateSwiftHeatGallery(v);
        const cfg = window._COMPLETE_PURCHASE_CONFIG;
        if (cfg) {
          const priceCents = parseKrText(v.price);
          const compareCents = v.compare ? parseKrText(v.compare) : priceCents;
          const discountPct =
            compareCents > priceCents ? Math.round((1 - priceCents / compareCents) * 100) : 0;
          const friendDiscountPct = discountPct + (Number(cfg.friendExtraDiscount) || 10);
          const friendKeep = Math.max(0, 100 - friendDiscountPct);
          const friendCents =
            compareCents > 0 ? Math.round((compareCents * friendKeep) / 100) : priceCents;
          cfg.prices = { 1: priceCents };
          cfg.compares = { 1: compareCents };
          cfg.discounts = { 1: discountPct };
          cfg.friendPrices = { 1: friendCents };
          cfg.friendDiscounts = { 1: friendDiscountPct };
          const colorKey = normalizeColorKey(v.color || (v.options && v.options[0]) || '');
          if (cfg.colorImages) {
            if (colorKey.includes('rosa')) cfg.defaultImage = cfg.colorImages.Rosa || cfg.defaultImage;
            else if (colorKey.includes('svart')) cfg.defaultImage = cfg.colorImages.Svart || cfg.defaultImage;
          }
        }
      }

      document.querySelectorAll('[data-add-to-cart], .sticky-atc__btn').forEach(b => {
        if (!v.available) {
          b.disabled = true;
          if (!b.classList.contains('sticky-atc__btn')) setAtcButtonText(b, 'Slutsåld');
        } else {
          b.disabled = false;
          if (!b.classList.contains('sticky-atc__btn')) {
            if (b.hasAttribute('data-complete-purchase')) {
              const priceLabel = String(v.price || '')
                .replace(/^kr\s*/i, '')
                .replace(/\s*kr\.?$/i, '')
                .trim();
              const atcLabel = priceLabel ? `Köp · ${priceLabel} kr` : 'Köp';
              b.dataset.originalText = atcLabel;
              setAtcButtonText(b, atcLabel);
            } else {
              restoreAtcButtonText(b);
              if (!getAtcLabelEl(b)) setAtcButtonText(b, 'Lägg i varukorg');
            }
          }
        }
      });
    }

    function updateSwiftHeatGallery(v) {
      const color = v.color || (v.options && v.options[0]) || '';
      const gallery = document.querySelector('.product-gallery--swiftheat');
      if (!gallery) return;

      const thumbs = gallery.querySelectorAll('.product-gallery__thumb');
      let firstVisible = null;
      let visibleCount = 0;

      thumbs.forEach((t) => {
        const c = t.dataset.color;
        const matches = !c || c === color;
        t.style.display = matches ? '' : 'none';
        t.classList.remove('active');
        if (matches) {
          visibleCount += 1;
          if (!firstVisible) firstVisible = t;
        }
      });

      const mainImg = gallery.querySelector('#MainProductImage');
      const nextSrc = (firstVisible && firstVisible.dataset.src) || v.image;
      if (mainImg && nextSrc) {
        mainImg.src = nextSrc;
        mainImg.removeAttribute('srcset');
        mainImg.sizes = '100vw';
      }
      if (firstVisible) firstVisible.classList.add('active');

      gallery.querySelectorAll('.product-gallery__nav').forEach((nav) => {
        nav.style.display = visibleCount > 1 ? '' : 'none';
      });
    }

    window._getCurrentQty = () => 1;
    window._getBundleItems = () => {
      const v = findStandardVariant();
      return v ? [{ id: v.id, quantity: 1 }] : [];
    };

    document.querySelectorAll('.product-option__value').forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        if (this.disabled) return;
        const fieldset = this.closest('.product-option');
        fieldset?.querySelectorAll('.product-option__value').forEach(b => b.classList.remove('active'));
        this.classList.add('active');
        updateStandardUI();
      });
    });

    updateStandardUI();
    return;
  }

  const hasColor = variants.some(v => v.farge);
  // Bundle-priser
  // Tillat per-produkt override via window._BUNDLE_* (settes i section-template før theme.js)
  const BUNDLE_PRICES    = window._BUNDLE_PRICES    || { 1: 'kr 749,00',  2: 'kr 1 199,00', 3: 'kr 1 499,00' };
  const BUNDLE_COMPARES  = window._BUNDLE_COMPARES  || { 1: 'kr 999,00',  2: 'kr 1 998,00', 3: 'kr 2 997,00' };
  const BUNDLE_DISCOUNTS = window._BUNDLE_DISCOUNTS || { 1: 25,           2: 40,            3: 50 };
  let currentQty = parseInt(document.querySelector('.package-option.active')?.dataset.qty || '1');
  const defaultColor = (variants.find(v => v.available) || variants[0]).farge;

  function readColorsFromPackage(qty) {
    const opt = document.querySelector(`.package-option[data-qty="${qty}"]`);
    if (!opt) return [];
    const colors = [];
    opt.querySelectorAll('[data-color-slot]').forEach(slotEl => {
      const active = slotEl.querySelector('.color-pill.active:not(.color-pill--soldout)')
        || slotEl.querySelector('.color-pill:not(.color-pill--soldout)');
      colors.push(active?.dataset.color || defaultColor);
    });
    return colors;
  }

  function normalizeColorKey(color) {
    return String(color || '')
      .toLowerCase()
      .replace(/å/g, 'a')
      .replace(/ä/g, 'a')
      .replace(/ö/g, 'o');
  }

  function resolvePaseColorName(trimmerColor, paseMap) {
    if (paseMap[trimmerColor]) return trimmerColor;
    const k = normalizeColorKey(trimmerColor);
    if (paseMap['Blå'] && (k.includes('bla') || k.includes('blue'))) return 'Blå';
    if (paseMap['Lila'] && (k.includes('lila') || k.includes('lilla') || k.includes('purple'))) return 'Lila';
    if (paseMap['Rosa']) return 'Rosa';
    return Object.keys(paseMap)[0] || trimmerColor;
  }

  const selectedColors = {
    1: readColorsFromPackage(1),
    2: readColorsFromPackage(2),
    3: readColorsFromPackage(3),
  };
  if (!selectedColors[1].length) selectedColors[1] = [defaultColor];
  if (!selectedColors[2].length) selectedColors[2] = [defaultColor];
  if (!selectedColors[3].length) selectedColors[3] = [defaultColor];
  let currentFarge = selectedColors[currentQty][0] || defaultColor;

  function findVariant(color) {
    const farge = color || currentFarge;
    return variants.find(v => !hasColor || v.farge === farge);
  }
  window._getCurrentQty = () => currentQty;
  window._getBundleColors = () => (selectedColors[currentQty] || []).slice();
  window._getBundleItems = () => {
    const color = (selectedColors[currentQty] || [])[0] || defaultColor;
    const primary =
      variants.find((vr) => (!hasColor || vr.farge === color) && vr.available) ||
      variants.find((vr) => !hasColor || vr.farge === color) ||
      variants.find((vr) => vr.available) ||
      variants[0];
    if (!primary) return [];

    // Pack variants (Naturborste etc.): one Shopify variant per package qty
    const packByQty = window._BUNDLE_VARIANT_BY_QTY;
    if (packByQty && typeof packByQty === 'object') {
      const packId = parseInt(packByQty[currentQty] || packByQty[String(currentQty)] || 0, 10);
      if (packId) return [{ id: packId, quantity: 1 }];
    }

    const items = [{ id: primary.id, quantity: 1 }];

    // Generic multi-product packages (GoSoft etc.): { 2: [variantId], 3: [id, id] }
    const byQty = window._BUNDLE_ADDON_BY_QTY;
    if (byQty && typeof byQty === 'object') {
      const addonIds = byQty[currentQty] || byQty[String(currentQty)] || [];
      addonIds.forEach((rawId) => {
        const id = parseInt(rawId, 10);
        if (id) items.push({ id, quantity: 1 });
      });
      return items;
    }

    const addons = window._BUNDLE_ADDONS || {};

    if (currentQty === 2 && addons.lotionStandard) {
      items.push({ id: parseInt(addons.lotionStandard, 10), quantity: 1 });
    }
    if (currentQty === 3) {
      if (addons.lotionStandard) {
        items.push({ id: parseInt(addons.lotionStandard, 10), quantity: 1 });
      }
      if (addons.afterShave) {
        items.push({ id: parseInt(addons.afterShave, 10), quantity: 1 });
      }
      const paseMap = addons.paseStandardByColor || {};
      const bagColor = resolvePaseColorName(color, paseMap);
      const paseId = parseInt(paseMap[bagColor], 10);
      if (paseId) {
        items.push({ id: paseId, quantity: 1 });
      }
    }

    return items;
  };

  function getBundleImageUrl(qty, color) {
    const img = document.querySelector(
      `.package-option[data-qty="${qty}"] .package-option__bundle-thumb img`
    );
    if (!img) return '';
    const src = bundleThumbSrc(img, color);
    return src || img.src || '';
  }

  window._getBundleMeta = () => {
    const labels = window._BUNDLE_LABELS || {
      1: 'Endast SilkTrim',
      2: 'SilkTrim & lotion',
      3: 'Komplett paket',
    };
    return {
      id: `bundle-${currentQty}-${Date.now()}`,
      title: labels[currentQty] || 'Paket',
      image: getBundleImageUrl(currentQty, currentFarge),
      qty: currentQty,
      primaryColor: (selectedColors[currentQty] || [currentFarge])[0] || currentFarge,
    };
  };

  const parseKr = s => parseFloat(String(s).replace(/[^\d,.-]/g, '').replace(/\s/g, '').replace(',', '.')) || 0;

  function updatePricesAndATC() {
    const packByQty = window._BUNDLE_VARIANT_BY_QTY;
    const packId = packByQty
      ? parseInt(packByQty[currentQty] || packByQty[String(currentQty)] || 0, 10)
      : 0;
    const v = (packId && variants.find((vr) => vr.id === packId)) || findVariant();
    if (!v) return;
    document.querySelectorAll('[data-add-to-cart], .sticky-atc__btn').forEach(b => b.dataset.variantId = v.id);
    const hiddenInput = document.querySelector('form input[name="id"]');
    if (hiddenInput) hiddenInput.value = v.id;

    const mainPrice = document.querySelector('.product-info__price');
    const mainCompare = document.querySelector('.product-info__compare');
    const mainBadge = document.querySelector('.product-info__badge');
    const isBundlePdp =
      !!document.querySelector('.product-page--glowtrim') ||
      !!document.querySelector('.package-option[data-qty]');
    const bundlePrice = isBundlePdp ? (BUNDLE_PRICES[currentQty] || v.price) : v.price;
    const bundleCompare = isBundlePdp ? (BUNDLE_COMPARES[currentQty] || v.compare) : v.compare;
    const bundleDiscount = isBundlePdp ? (BUNDLE_DISCOUNTS[currentQty] || 0) : 0;
    if (mainPrice) mainPrice.textContent = bundlePrice;
    if (mainCompare) {
      if (bundleCompare) { mainCompare.textContent = bundleCompare; mainCompare.style.display = ''; }
      else { mainCompare.style.display = 'none'; }
    }
    if (mainBadge) {
      if (bundleDiscount > 0) {
        mainBadge.textContent = 'Spar ' + bundleDiscount + '%';
        mainBadge.style.display = '';
      } else { mainBadge.style.display = 'none'; }
    }

    // SilkTrim / Naturborste: ATC = "Köp · pris" (går til Slutför köpet)
    const packAtcRoot = document.querySelector('.product-page--glowtrim, .product-page--naturborste');
    if (packAtcRoot) {
      const priceLabel = String(bundlePrice || '')
        .replace(/^kr\s*/i, '')
        .replace(/\s*kr\.?$/i, '')
        .trim();
      const atcLabel = packAtcRoot.classList.contains('product-page--naturborste')
        ? (priceLabel ? `Välj ren rutin · ${priceLabel} kr` : 'Välj ren rutin')
        : (priceLabel ? `Köp · ${priceLabel} kr` : 'Köp');
      packAtcRoot.querySelectorAll('[data-add-to-cart]').forEach((b) => {
        if (b.disabled) return;
        b.dataset.originalText = atcLabel;
        setAtcButtonText(b, atcLabel);
      });
    }
  }

  function bundleThumbSrc(img, color) {
    const key = normalizeColorKey(color);
    let src = img.dataset.bundleDefault;
    if (key.includes('ceriserosa')) {
      src = img.dataset.bundleCeriserosa || img.dataset.bundleRosa || src;
    } else if (key.includes('rosa') || key.includes('pink') || key.includes('rose')) {
      src = img.dataset.bundleRosa || src;
    } else if (
      key.includes('violett') ||
      key.includes('violet') ||
      key.includes('lila') ||
      key.includes('lilla') ||
      key.includes('purple')
    ) {
      src = img.dataset.bundleCeriserosa || img.dataset.bundleViolett || img.dataset.bundleLila || src;
    } else if (key.includes('bla') || key.includes('blue')) {
      src = img.dataset.bundleBla || src;
    }
    return src;
  }

  function bundleThumbImage(qty, color) {
    const img = document.querySelector(
      `.package-option[data-qty="${qty}"] .package-option__bundle-thumb img`
    );
    if (!img || !img.dataset.bundleDefault) return;
    const src = bundleThumbSrc(img, color);
    if (src) img.src = src;
  }

  function filterGalleryByColor() {
    if (!hasColor) return;
    // SilkTrim: ett galleri for alle farger — farge vises kun i pakkevelgeren
    if (document.querySelector('.product-page--glowtrim')) return;
    const thumbs = document.querySelectorAll('.product-gallery__thumb, .home-product__thumb');
    let firstVisible = null;
    thumbs.forEach(t => {
      const c = t.dataset.color;
      const matches = !c || c === currentFarge;
      t.style.display = matches ? '' : 'none';
      if (matches && !firstVisible) firstVisible = t;
      t.classList.remove('active');
    });
    if (firstVisible) {
      firstVisible.classList.add('active');
      const mainImg = document.querySelector('.product-gallery__main img, #HomeMainImg img');
      const src = firstVisible.dataset.src;
      if (mainImg && src) {
        mainImg.src = src;
        mainImg.removeAttribute('srcset');
        mainImg.removeAttribute('sizes');
      }
    }
  }

  function scrollToAddToCartButton() {
    const btn = document.querySelector('.product-info__atc');
    if (!btn) return;
    btn.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  // Pakke-klikk (setter quantity / bundle)
  document.querySelectorAll('.package-option').forEach(opt => {
    opt.addEventListener('click', function(e) {
      if (e.target.closest('.color-pill')) return;
      // Philips/Venus product options on SilkTrim tabs — handled by silktrim-brand-tabs.js
      if (this.hasAttribute('data-brand-product')) return;

      const wasAlreadyActive = this.classList.contains('active');

      document
        .querySelectorAll('.package-selector:not(.package-selector--brand) .package-option')
        .forEach((o) => o.classList.remove('active'));
      this.classList.add('active');
      currentQty = parseInt(this.dataset.qty) || 1;
      selectedColors[currentQty] = readColorsFromPackage(currentQty);
      currentFarge = selectedColors[currentQty][0] || defaultColor;
      filterGalleryByColor();
      updatePricesAndATC();
      if (currentQty === 1 || currentQty === 2 || currentQty === 3) {
        bundleThumbImage(currentQty, currentFarge);
      }

      if (wasAlreadyActive) {
        scrollToAddToCartButton();
      }
    });
  });

  document.querySelectorAll('.color-pill').forEach(pill => {
    pill.addEventListener('click', function(e) {
      e.stopPropagation();
      if (this.disabled || this.classList.contains('color-pill--soldout')) return;
      const color = this.dataset.color;
      const slot = parseInt(this.dataset.slot, 10) - 1;
      const pkg = this.closest('.package-option');
      const qty = parseInt(pkg?.dataset.qty || String(currentQty), 10);
      const slotEl = this.closest('[data-color-slot]');
      slotEl?.querySelectorAll('.color-pill').forEach(p => p.classList.remove('active'));
      this.classList.add('active');
      if (!selectedColors[qty]) selectedColors[qty] = [];
      selectedColors[qty][slot] = color;
      if (qty === currentQty) {
        currentFarge = color;
        filterGalleryByColor();
        updatePricesAndATC();
      }
      if (qty === 1 || qty === 2 || qty === 3) bundleThumbImage(qty, color);
    });
  });

  bundleThumbImage(1, selectedColors[1][0] || defaultColor);
  bundleThumbImage(2, selectedColors[2]?.[0] || defaultColor);
  bundleThumbImage(3, selectedColors[3]?.[0] || defaultColor);

  function markSoldOutColors() { /* sold-out state rendered in Liquid */ }

  // Oppdater ATC-knapp basert på tilgjengelighet
  function updateATCAvailability() {
    const v = findVariant();
    document.querySelectorAll('[data-add-to-cart], .sticky-atc__btn').forEach(b => {
      const isSticky = b.classList.contains('sticky-atc__btn');
      if (!v || !v.available) {
        b.disabled = true;
        // Bevar struktur på sticky-knapp (span-grupper)
        if (isSticky) {
          const label = b.querySelector('.sticky-atc__label');
          const sep   = b.querySelector('.sticky-atc__sep');
          const price = b.querySelector('.sticky-atc__price');
          if (label) label.textContent = 'Slutsåld';
          if (sep)   sep.style.display = 'none';
          if (price) price.style.display = 'none';
        } else {
          setAtcButtonText(b, 'Slutsåld');
        }
        b.style.opacity = '0.55';
        b.style.cursor = 'not-allowed';
      } else {
        b.disabled = false;
        if (isSticky) {
          const label = b.querySelector('.sticky-atc__label');
          const sep   = b.querySelector('.sticky-atc__sep');
          const price = b.querySelector('.sticky-atc__price');
          if (label) label.textContent = b.dataset.originalText || 'Lägg i varukorg';
          if (sep)   sep.style.display = '';
          if (price) price.style.display = '';
        } else if (!document.querySelector('.product-page--glowtrim')) {
          if (!b.dataset.originalText) {
            const existing = getAtcLabelEl(b) ? getAtcLabelEl(b).textContent.trim() : '';
            b.dataset.originalText = existing || 'Lägg i varukorg';
          }
          restoreAtcButtonText(b);
        }
        b.style.opacity = '';
        b.style.cursor = '';
      }
    });
  }

  // Oppdater "Kun X igjen på lager"-tekst
  function updateStockIndicator() {
    const v = findVariant();
    const stock = document.querySelector('.stock-indicator');
    if (!stock || !v) return;
    const stockLabel = stock.querySelector('.stock-indicator__stock');
    const shipEl = stock.querySelector('.stock-indicator__ship');
    const iconEl = stock.querySelector('.stock-indicator__icon');
    const textEl = stockLabel || stock.querySelector('span:not(.stock-dot):not(.stock-indicator__copy):not(.stock-indicator__icon):not(.stock-indicator__ship)');
    const dot = stock.querySelector('.stock-dot');
    const setSplitVisibility = (showShip) => {
      if (shipEl) shipEl.hidden = !showShip;
      if (iconEl) iconEl.hidden = !showShip;
    };
    if (!v.available) {
      stock.style.display = 'none';
      return;
    }
    stock.style.display = '';
    if (v.tracked && v.inventory > 0 && v.inventory < 18) {
      if (textEl) textEl.textContent = `Bara ${v.inventory} kvar i lager`;
      setSplitVisibility(false);
      if (dot) dot.style.background = '#e67e22';
    } else if (v.tracked && v.inventory > 0 && v.inventory < 30) {
      if (textEl) textEl.textContent = 'Bara några få kvar i lager';
      setSplitVisibility(false);
      if (dot) dot.style.background = '#e67e22';
    } else if (v.tracked && v.inventory === 0) {
      stock.style.display = 'none';
    } else {
      if (stockLabel) {
        stockLabel.textContent = 'Få kvar i lager';
        setSplitVisibility(true);
      } else if (textEl) {
        textEl.textContent = 'Få kvar i lager';
      }
      if (dot) dot.style.background = '#e67e22';
    }
  }

  // Wrap updatePricesAndATC to also handle availability + stock
  const _origUpdate = updatePricesAndATC;
  updatePricesAndATC = function() {
    _origUpdate();
    updateATCAvailability();
    updateStockIndicator();
  };

  // Init
  markSoldOutColors();
  filterGalleryByColor();
  updatePricesAndATC();
})();

// LIGHTBOX deaktivert på forsiden
document.querySelectorAll('#HomeMainImg img').forEach(el => {
  el.style.cursor = 'default';
});

// ACCORDION
document.querySelectorAll('.accordion__trigger').forEach(trigger => {
  trigger.addEventListener('click', function() {
    const item = this.closest('.accordion__item');
    const body = item.querySelector('.accordion__body');
    const isOpen = item.classList.contains('open');
    document.querySelectorAll('.accordion__item').forEach(i => {
      i.classList.remove('open');
      i.querySelector('.accordion__body')?.classList.remove('open');
    });
    if (!isOpen) {
      item.classList.add('open');
      body?.classList.add('open');
    }
  });
});

// STICKY ATC (standard produktsider — ikke SilkTrim / GoSoft / Swift Heat)
const stickyAtc = document.querySelector('.sticky-atc:not(.sticky-atc--glowtrim):not(.sticky-atc--gosoft):not(.sticky-atc--swiftheat)');
const atcBtn = document.querySelector('.product-info__atc');
if (stickyAtc && atcBtn && !document.querySelector('.product-page--glowtrim') && !document.querySelector('.product-page--gosoft') && !document.querySelector('.product-page--swiftheat')) {
  const observer = new IntersectionObserver(entries => {
    stickyAtc.classList.toggle('visible', !entries[0].isIntersecting);
  }, { threshold: 0.1 });
  observer.observe(atcBtn);

  stickyAtc.querySelector('.sticky-atc__btn')?.addEventListener('click', function(e) {
    e.preventDefault();
    if (typeof window._getBundleItems === 'function') {
      const items = window._getBundleItems();
      if (items?.length) {
        addBundleToCart(items);
        return;
      }
    }
    const variantId = this.dataset.variantId || atcBtn?.dataset.variantId;
    if (variantId) addToCart(parseInt(variantId), 1);
  });
}

// STICKY BAR — Swift Heat: show after ATC scrolls past; scroll to buy info under gallery
const swiftheatSticky = document.querySelector('.sticky-atc--swiftheat');
const swiftheatAtc = document.querySelector('.product-page--swiftheat .product-info__atc, .product-page--swiftheat .sh-atc');
const swiftheatBuy = document.getElementById('swiftheat-buy') || document.getElementById('swiftheat-offer');
if (swiftheatSticky && swiftheatAtc) {
  const syncSwiftHeatSticky = () => {
    const rect = swiftheatAtc.getBoundingClientRect();
    const show = rect.bottom < 0;
    swiftheatSticky.classList.toggle('visible', show);
    swiftheatSticky.setAttribute('aria-hidden', show ? 'false' : 'true');
  };
  const swiftheatStickyObserver = new IntersectionObserver(() => {
    syncSwiftHeatSticky();
  }, { threshold: [0, 0.1, 1] });
  swiftheatStickyObserver.observe(swiftheatAtc);
  window.addEventListener('scroll', syncSwiftHeatSticky, { passive: true });
  syncSwiftHeatSticky();

  swiftheatSticky.querySelector('.sticky-atc__btn')?.addEventListener('click', (e) => {
    e.preventDefault();
    (swiftheatBuy || swiftheatAtc).scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
}

// STICKY BAR — SilkTrim: scroll back to package selector
const glowtrimSticky = document.querySelector('.sticky-atc--glowtrim');
const glowtrimAtc = document.querySelector('.product-page--glowtrim .product-info__atc');
const glowtrimOffer = document.getElementById('silktrim-offer');

if (glowtrimSticky && glowtrimAtc && glowtrimOffer) {
  const glowtrimStickyObserver = new IntersectionObserver((entries) => {
    glowtrimSticky.classList.toggle('visible', !entries[0].isIntersecting);
  }, { threshold: 0.1 });
  glowtrimStickyObserver.observe(glowtrimAtc);

  glowtrimSticky.querySelector('.sticky-atc__btn')?.addEventListener('click', (e) => {
    e.preventDefault();
    glowtrimOffer.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
}

// STICKY BAR — GoSoft: scroll to packages when present, else add current variant
const gosoftSticky = document.querySelector('.sticky-atc--gosoft');
const gosoftAtc = document.querySelector('.product-page--gosoft .product-info__atc');
const gosoftOffer = document.getElementById('gosoft-offer');

if (gosoftSticky && gosoftAtc) {
  const gosoftStickyObserver = new IntersectionObserver((entries) => {
    gosoftSticky.classList.toggle('visible', !entries[0].isIntersecting);
  }, { threshold: 0.1 });
  gosoftStickyObserver.observe(gosoftAtc);

  gosoftSticky.querySelector('.sticky-atc__btn')?.addEventListener('click', (e) => {
    e.preventDefault();
    if (gosoftOffer) {
      gosoftOffer.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    if (typeof window._getBundleItems === 'function') {
      const items = window._getBundleItems();
      if (items?.length) {
        const meta = typeof window._getBundleMeta === 'function' ? window._getBundleMeta() : null;
        addBundleToCart(items, meta);
        return;
      }
    }
    const stickyBtn = e.currentTarget;
    const variantId = stickyBtn?.dataset.variantId || gosoftAtc?.dataset.variantId;
    if (variantId) addToCart(parseInt(variantId, 10), 1);
  });
}

let toastHideTimer = null;

// TOAST
function showToast(msg) {
  let toast = document.querySelector('.toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.className = 'toast';
    document.body.appendChild(toast);
  }
  if (toastHideTimer) {
    clearTimeout(toastHideTimer);
    toastHideTimer = null;
  }
  toast.textContent = msg;
  toast.classList.add('visible');
  toastHideTimer = setTimeout(() => {
    toast.classList.remove('visible');
    toastHideTimer = null;
  }, 2800);
}

// NEWSLETTER
document.querySelector('.newsletter__form')?.addEventListener('submit', function(e) {
  const email = this.querySelector('input').value;
  if (!email) e.preventDefault();
});

// MOBILE MENU
const mobileNav = document.querySelector('.mobile-nav');
function openMobileNav() {
  mobileNav?.classList.add('active');
  lockScroll();
}
function closeMobileNav() {
  mobileNav?.classList.remove('active');
  unlockScroll();
}
document.querySelector('.mobile-menu-btn')?.addEventListener('click', openMobileNav);
document.querySelector('.mobile-nav__close')?.addEventListener('click', closeMobileNav);
document.querySelector('.mobile-nav__overlay')?.addEventListener('click', closeMobileNav);

// HOME PRODUCT GALLERY + AUTOPLAY
function _isGalleryThumbActive(t) {
  if (!t || t.style.display === 'none') return false;
  return getComputedStyle(t).display !== 'none';
}

function _makeAutoplay(thumbSelector, imgSelector, interval) {
  const thumbs = () => [...document.querySelectorAll(thumbSelector)].filter(_isGalleryThumbActive);
  const mainImg = () => document.querySelector(imgSelector);
  const galleryMain = () => document.querySelector('.product-gallery__main');

  function isAnimated(thumb) {
    return thumb?.dataset.animated === 'true' || (thumb?.dataset.src || '').includes('.gif');
  }

  function showVideo(thumb) {
    const wrap = galleryMain();
    if (!wrap) return;
    let video = wrap.querySelector('.product-gallery__video');
    const sources = thumb?.dataset.videoSources;
    if (!sources) return;
    let parsed;
    try { parsed = JSON.parse(sources); } catch { return; }
    if (!parsed?.length) return;

    wrap.querySelector('#MainProductImage')?.remove();
    if (!video) {
      video = document.createElement('video');
      video.id = 'MainProductVideo';
      video.className = 'product-gallery__video';
      video.autoplay = true;
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.preload = 'metadata';
      wrap.prepend(video);
    }
    video.innerHTML = '';
    parsed.forEach((source) => {
      const el = document.createElement('source');
      el.src = source.url;
      el.type = source.mime_type;
      video.appendChild(el);
    });
    video.load();
    video.play().catch(() => {});
  }

  function showImage(thumb, src) {
    const wrap = galleryMain();
    if (!wrap) return;
    wrap.querySelector('.product-gallery__video')?.remove();

    let img = wrap.querySelector('#MainProductImage');
    if (!img) {
      img = document.createElement('img');
      img.id = 'MainProductImage';
      img.className = 'product-gallery__image';
      wrap.prepend(img);
    }

    if (isAnimated(thumb)) {
      img.classList.add('product-gallery__image--gif');
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      if (img.src !== src) {
        img.src = src;
      } else {
        img.src = '';
        img.src = src;
      }
      return;
    }

    img.classList.remove('product-gallery__image--gif');
    const tmp = new Image();
    const swap = () => {
      img.src = src;
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      wrap.classList.remove('is-loading');
    };
    if (tmp.complete || src === img.src) {
      swap();
    } else {
      wrap.classList.add('is-loading');
      tmp.onload = swap;
      tmp.onerror = swap;
      setTimeout(swap, 1500);
    }
    tmp.src = src;
  }

  function goTo(index) {
    const all = thumbs();
    if (!all.length) return;
    index = ((index % all.length) + all.length) % all.length;
    const thumb = all[index];
    const src = thumb.dataset.src;

    if (thumb.dataset.mediaType === 'video') {
      showVideo(thumb);
    } else if (src) {
      showImage(thumb, src);
    }

    all.forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
  }

  function nextAutoplayIndex() {
    const all = thumbs();
    const cur = all.findIndex(t => t.classList.contains('active'));
    if (cur < 0) return 0;
    for (let step = 1; step <= all.length; step += 1) {
      const candidate = (cur + step) % all.length;
      if (!isAnimated(all[candidate])) return candidate;
    }
    return (cur + 1) % all.length;
  }

  let timer = null;
  let restartTimeout = null;
  function start() {
    if (timer) clearInterval(timer);
    const active = thumbs().find(t => t.classList.contains('active'));
    if (isAnimated(active)) return;
    timer = setInterval(() => {
      goTo(nextAutoplayIndex());
    }, interval);
  }
  function stop() {
    if (timer) { clearInterval(timer); timer = null; }
    if (restartTimeout) { clearTimeout(restartTimeout); restartTimeout = null; }
  }
  function scheduleRestart(delay) {
    if (restartTimeout) clearTimeout(restartTimeout);
    restartTimeout = setTimeout(() => { restartTimeout = null; start(); }, delay);
  }
  function reset() { stop(); start(); }

  const wrap = document.querySelector(imgSelector.split(' ')[0]);
  if (!wrap) return null;

  start();
  if (window.matchMedia('(hover: hover)').matches) {
    wrap.addEventListener('mouseenter', stop);
    wrap.addEventListener('mouseleave', start);
  }

  let sx = 0, sy = 0;
  wrap.addEventListener('touchstart', e => {
    sx = e.changedTouches[0].screenX;
    sy = e.changedTouches[0].screenY;
    stop();
  }, { passive: true });
  wrap.addEventListener('touchend', e => {
    const dx = sx - e.changedTouches[0].screenX, dy = sy - e.changedTouches[0].screenY;
    if (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy)) {
      const all = thumbs(), cur = all.findIndex(t => t.classList.contains('active'));
      goTo(dx > 0 ? cur + 1 : cur - 1);
    }
    scheduleRestart(2500);
  }, { passive: true });

  return { goTo, reset, stop };
}

// Hjälper: finn riktig index i SYNLIGE thumbs (ikke skjulte fra annen farge)
function _visibleIndex(thumb, selector) {
  const visible = [...document.querySelectorAll(selector)].filter(_isGalleryThumbActive);
  return visible.indexOf(thumb);
}

// Produkt-side galleri
const _pgResult = _makeAutoplay('.product-gallery__thumb', '.product-gallery__main img', 3500);
if (_pgResult) {
  window._productGalleryGoTo = _pgResult.goTo;
  // Pilnavigasjon — bruker samme pause/restart-logikk som touch/click
  function _pgNav(dir) {
    const visible = [...document.querySelectorAll('.product-gallery__thumb')].filter(_isGalleryThumbActive);
    if (!visible.length) return;
    const cur = visible.findIndex(t => t.classList.contains('active'));
    const next = (cur + dir + visible.length) % visible.length;
    _pgResult.goTo(next);
    _pgResult.stop();
    setTimeout(() => _pgResult.reset(), 2500);
  }
  document.querySelector('.product-gallery__nav--prev')?.addEventListener('click', (e) => {
    e.stopPropagation();
    _pgNav(-1);
  });
  document.querySelector('.product-gallery__nav--next')?.addEventListener('click', (e) => {
    e.stopPropagation();
    _pgNav(1);
  });

  const galleryMain = document.querySelector('.product-gallery__main');
  galleryMain?.addEventListener('click', (e) => {
    if (e.target.closest('.product-gallery__nav')) return;
    const visible = [...document.querySelectorAll('.product-gallery__thumb')].filter(_isGalleryThumbActive);
    if (visible.length < 2) return;
    const rect = galleryMain.getBoundingClientRect();
    const x = e.clientX - rect.left;
    _pgNav(x < rect.width / 2 ? -1 : 1);
  });

  document.querySelectorAll('.product-gallery__thumb').forEach(t => {
    t.addEventListener('click', () => {
      const idx = _visibleIndex(t, '.product-gallery__thumb');
      if (idx >= 0) { _pgResult.goTo(idx); _pgResult.stop(); setTimeout(() => _pgResult.reset(), 2500); }
    });
  });
}

// Forside produkt-galleri
const _hgResult = _makeAutoplay('.home-product__thumb', '#HomeMainImg img', 3500);
if (_hgResult) {
  window._homeGalleryGoTo = _hgResult.goTo;
  document.querySelectorAll('.home-product__thumb').forEach(t => {
    t.addEventListener('click', () => {
      const idx = _visibleIndex(t, '.home-product__thumb');
      if (idx >= 0) { _hgResult.goTo(idx); _hgResult.stop(); setTimeout(() => _hgResult.reset(), 2500); }
    });
  });
}

// INIT
fetchCart();

/* ============================================ */
/* 360 AUTO-SPIN — disabled (frames not seq.)  */
/* ============================================ */
(function() {
  const root = document.getElementById('ZhSpin');
  if (!root) return;
  return; // disabled — using static float animation instead
  const frames = [...root.querySelectorAll('.zh-featured__frame')];
  if (frames.length < 2) return;

  // Preload all frames
  frames.forEach(f => { f.style.display = 'block'; });

  let active = 0;
  let dragging = false;
  let dragStartX = 0;
  let dragStartFrame = 0;
  let dragMoved = false;
  let lastFrameTime = 0;
  let dragResumeAt = 0;
  const FRAME_MS = 260;          // ca 2.6s per full rotasjon — crossfade overlapper
  const RESUME_DELAY = 1200;     // pause litt etter slipp før loop fortsetter

  function setFrame(i) {
    const next = ((i % frames.length) + frames.length) % frames.length;
    if (next === active) return;
    frames[active].classList.remove('is-active');
    frames[next].classList.add('is-active');
    active = next;
  }

  function tick(t) {
    if (!dragging && t >= dragResumeAt) {
      if (!lastFrameTime) lastFrameTime = t;
      if (t - lastFrameTime >= FRAME_MS) {
        setFrame(active + 1);
        lastFrameTime = t;
      }
    } else {
      lastFrameTime = 0;
    }
    requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);

  // Drag-to-scrub (interrupts auto, resumes after RESUME_DELAY)
  function onPointerDown(e) {
    dragging = true;
    dragMoved = false;
    dragStartX = (e.touches ? e.touches[0].clientX : e.clientX);
    dragStartFrame = active;
    root.style.cursor = 'grabbing';
    root.classList.add('is-dragging');
  }
  function onPointerMove(e) {
    if (!dragging) return;
    const x = (e.touches ? e.touches[0].clientX : e.clientX);
    const dx = x - dragStartX;
    if (Math.abs(dx) > 4) dragMoved = true;
    const w = root.offsetWidth || 400;
    const steps = Math.round((dx / w) * frames.length * 1.5);
    setFrame(dragStartFrame + steps);
    if (dragMoved && e.cancelable) e.preventDefault();
  }
  function onPointerUp() {
    if (!dragging) return;
    dragging = false;
    root.style.cursor = 'grab';
    root.classList.remove('is-dragging');
    dragResumeAt = performance.now() + RESUME_DELAY;
  }

  root.addEventListener('mousedown', onPointerDown);
  window.addEventListener('mousemove', onPointerMove);
  window.addEventListener('mouseup', onPointerUp);
  root.addEventListener('touchstart', onPointerDown, { passive: true });
  root.addEventListener('touchmove', onPointerMove, { passive: false });
  root.addEventListener('touchend', onPointerUp);

  // Pause when tab is hidden (save CPU)
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) dragResumeAt = Infinity;
    else dragResumeAt = performance.now() + 200;
  });

  // Pause if section is off-screen (perf)
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(entries => {
      entries.forEach(en => {
        if (en.isIntersecting) dragResumeAt = Math.min(dragResumeAt, performance.now() + 200);
        else dragResumeAt = Infinity;
      });
    }, { threshold: 0.1 }).observe(root);
  }
})();

/* LIVE SOCIAL PROOF — viser 9-45 personer som tittar just nu */
(function() {
  const viewersEl = document.getElementById('liveViewers');
  const soldEl = document.getElementById('liveSold');
  if (!viewersEl && !soldEl) return;

  const VIEWERS_MIN = 9;
  const VIEWERS_MAX = 45;

  const wrap = viewersEl ? viewersEl.closest('.live-proof') : soldEl ? soldEl.closest('.live-proof') : null;
  if (wrap) wrap.style.display = '';

  function getViewersBase() {
    return VIEWERS_MIN + Math.floor(Math.random() * (VIEWERS_MAX - VIEWERS_MIN + 1));
  }

  function getSoldBase() {
    return 8 + Math.floor(Math.random() * 5);
  }

  function animateNumber(el, from, to, duration = 600) {
    if (!el) return;
    const start = performance.now();
    function step(now) {
      const t = Math.min(1, (now - start) / duration);
      const val = Math.round(from + (to - from) * t);
      el.textContent = val;
      if (t < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  let viewers = getViewersBase();
  let sold = getSoldBase();
  if (viewersEl) viewersEl.textContent = viewers;
  if (soldEl) soldEl.textContent = sold;

  // Oppdater viewers hvert 15-30 sek, hold 9-45
  function tickViewers() {
    const drift = Math.floor(Math.random() * 13) - 6; // -6 til +6
    const target = Math.max(VIEWERS_MIN, Math.min(VIEWERS_MAX, viewers + drift));
    animateNumber(viewersEl, viewers, target, 800);
    viewers = target;
    setTimeout(tickViewers, 15000 + Math.random() * 15000);
  }

  // Oppdater sold-teller hvert 4-9 min (sjeldnere, +1 av gangen for å bygge urgency)
  function tickSold() {
    if (Math.random() < 0.6) {
      const target = Math.min(sold + 1, 28);
      animateNumber(soldEl, sold, target, 500);
      sold = target;
    }
    setTimeout(tickSold, 240000 + Math.random() * 300000);
  }

  if (viewersEl) setTimeout(tickViewers, 8000);
  if (soldEl)    setTimeout(tickSold, 60000);
})();

// MINI REVIEWS SWIPER
(function initMiniSwiper(){
  const root = document.querySelector('[data-mini-swiper]');
  if (!root) return;
  const track = root.querySelector('[data-mini-track]');
  const slides = Array.from(track.children);
  const dotsWrap = root.querySelector('[data-mini-dots]');
  const prevBtn = root.querySelector('[data-mini-prev]');
  const nextBtn = root.querySelector('[data-mini-next]');
  if (!slides.length) return;

  let idx = 0;
  let autoTimer = null;

  // Lag dots
  slides.forEach((_, i) => {
    const d = document.createElement('button');
    d.type = 'button';
    d.className = 'mini-swiper__dot' + (i === 0 ? ' is-active' : '');
    d.setAttribute('aria-label', `Anmeldelse ${i+1}`);
    d.addEventListener('click', () => go(i, true));
    dotsWrap.appendChild(d);
  });
  const dots = Array.from(dotsWrap.children);

  function go(n, userTriggered) {
    idx = (n + slides.length) % slides.length;
    track.style.transform = `translateX(-${idx * 100}%)`;
    dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
    if (userTriggered) restartAuto();
  }

  function next(){ go(idx + 1); }
  function prev(){ go(idx - 1); }

  prevBtn.addEventListener('click', () => { prev(); restartAuto(); });
  nextBtn.addEventListener('click', () => { next(); restartAuto(); });

  // Touch / swipe
  let startX = 0, deltaX = 0, dragging = false;
  track.addEventListener('touchstart', e => {
    startX = e.touches[0].clientX; deltaX = 0; dragging = true;
    track.style.transition = 'none';
  }, { passive: true });
  track.addEventListener('touchmove', e => {
    if (!dragging) return;
    deltaX = e.touches[0].clientX - startX;
    track.style.transform = `translateX(calc(-${idx * 100}% + ${deltaX}px))`;
  }, { passive: true });
  track.addEventListener('touchend', () => {
    if (!dragging) return;
    dragging = false;
    track.style.transition = '';
    if (Math.abs(deltaX) > 40) {
      if (deltaX < 0) next(); else prev();
    } else {
      go(idx);
    }
    restartAuto();
  });

  function startAuto(){ autoTimer = setInterval(next, 5500); }
  function restartAuto(){ clearInterval(autoTimer); startAuto(); }
  startAuto();

  // Pause auto når synlig på desktop hover
  root.addEventListener('mouseenter', () => clearInterval(autoTimer));
  root.addEventListener('mouseleave', startAuto);
})();

// SilkTrim — vertikala omdömen, visa fler (max antal i listan)
(function initGlowtrimReviews() {
  const section = document.querySelector('.glowtrim-reviews');
  if (!section) return;

  const list = section.querySelector('[data-glowtrim-reviews-list]');
  const btn = section.querySelector('[data-glowtrim-reviews-more]');
  if (!list || !btn) return;

  const total = parseInt(list.dataset.totalReviews, 10) || 0;
  const hiddenItems = () =>
    [...section.querySelectorAll('.glowtrim-review--hidden')];

  function visibleCount() {
    return list.querySelectorAll('[data-review-item]:not(.glowtrim-review--hidden)').length;
  }

  function updateControls() {
    const remaining = hiddenItems().length;
    const atEnd = remaining === 0 || visibleCount() >= total;
    btn.hidden = atEnd;
    btn.disabled = atEnd;
  }

  btn.addEventListener('click', () => {
    const remaining = hiddenItems().length;
    if (!remaining || visibleCount() >= total) {
      updateControls();
      return;
    }
    const batch = Math.min(
      parseInt(btn.dataset.batch, 10) || 3,
      remaining,
      total - visibleCount()
    );
    hiddenItems()
      .slice(0, batch)
      .forEach((el) => el.classList.remove('glowtrim-review--hidden'));
    updateControls();
  });

  updateControls();
})();

// SilkTrim / GoSoft — click preview review → scroll to full review below
(function initGlowtrimReviewPreviewLinks() {
  const roots = [
    ...document.querySelectorAll('.product-page--glowtrim [data-mini-swiper], .product-page--gosoft [data-mini-swiper]'),
    ...document.querySelectorAll('.glowtrim-reviews-preview'),
  ];
  if (!roots.length) return;

  function revealAndScroll(reviewIndex) {
    const target = document.getElementById(`glowtrim-review-${reviewIndex}`);
    if (!target) {
      document.getElementById('anmeldelser')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    if (target.classList.contains('glowtrim-review--hidden')) {
      target.classList.remove('glowtrim-review--hidden');
      const section = document.querySelector('.glowtrim-reviews');
      const moreBtn = section?.querySelector('[data-glowtrim-reviews-more]');
      if (moreBtn && !section.querySelector('.glowtrim-review--hidden')) {
        moreBtn.hidden = true;
        moreBtn.disabled = true;
      }
    }

    requestAnimationFrame(() => {
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      target.classList.add('glowtrim-review--highlight');
      window.setTimeout(() => target.classList.remove('glowtrim-review--highlight'), 2000);
    });
  }

  roots.forEach((root) => {
    root.querySelectorAll('[data-scroll-to-review]').forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        revealAndScroll(el.dataset.scrollToReview);
      });
      el.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          revealAndScroll(el.dataset.scrollToReview);
        }
      });
    });
  });
})();

document.getElementById('scrollToTop')?.addEventListener('click', () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
});

document.querySelectorAll('[data-scroll-to]').forEach((link) => {
  link.addEventListener('click', (e) => {
    const target = document.querySelector(link.dataset.scrollTo);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
});
